<template>
  <div class="bracket-only-container">
    <div class="bracket-section">
      <h2 class="bracket-title">Turnerings Bracket</h2>
      <div class="ncaa-layout">
        <div class="tree tree-left">
          <div class="tree-title">Vänster Träd</div>

          <div class="bracket-round r1">
            <div class="round-label">Runda 1</div>
            <div class="match" v-for="(match, i) in bracket.left.round1" :key="'l-r1-' + i">
              <div class="match-time">{{ match.time }}</div>
              <div class="team blue-team" :class="{ winner: match.winner === match.team1 }"><span class="team-name">{{
                  match.team1 }}</span><span v-if="match.score1 !== undefined" class="team-score">{{ match.score1
                  }}</span></div>
              <div class="team red-team" :class="{ winner: match.winner === match.team2 }"><span class="team-name">{{
                  match.team2 }}</span><span v-if="match.score2 !== undefined" class="team-score">{{ match.score2
                  }}</span></div>
            </div>
          </div>

          <div class="bracket-round r2">
            <div class="round-label">Kvartsfinal</div>
            <div class="match" v-for="(match, i) in bracket.left.round2" :key="'l-r2-' + i">
              <div class="match-time">{{ match.time }}</div>
              <div class="team blue-team" :class="{ winner: match.winner === match.team1 }"><span class="team-name">{{
                  match.team1 }}</span><span v-if="match.score1 !== undefined" class="team-score">{{ match.score1
                  }}</span></div>
              <div class="team red-team" :class="{ winner: match.winner === match.team2 }"><span class="team-name">{{
                  match.team2 }}</span><span v-if="match.score2 !== undefined" class="team-score">{{ match.score2
                  }}</span></div>
            </div>
          </div>

          <div class="bracket-round r3">
            <div class="round-label">Semifinal</div>
            <div class="match" v-for="(match, i) in bracket.left.round3" :key="'l-r3-' + i">
              <div class="match-time">{{ match.time }}</div>
              <div class="team blue-team" :class="{ winner: match.winner === match.team1 }"><span class="team-name">{{
                  match.team1 }}</span><span v-if="match.score1 !== undefined" class="team-score">{{ match.score1
                  }}</span></div>
              <div class="team red-team" :class="{ winner: match.winner === match.team2 }"><span class="team-name">{{
                  match.team2 }}</span><span v-if="match.score2 !== undefined" class="team-score">{{ match.score2
                  }}</span></div>
            </div>
          </div>
        </div>

        <div class="center-final">
          <div class="round-label">Grand Final (Bo3)</div>
          <div class="match final-match">
            <div class="match-time">{{ bracket.grandFinal.time }}</div>
            <div class="team blue-team" :class="{ winner: bracket.grandFinal.winner === bracket.grandFinal.team1 }">
              <span class="team-name">{{ bracket.grandFinal.team1 }}</span><span
                v-if="bracket.grandFinal.score1 !== undefined" class="team-score">{{ bracket.grandFinal.score1 }}</span>
            </div>
            <div class="team red-team" :class="{ winner: bracket.grandFinal.winner === bracket.grandFinal.team2 }"><span
                class="team-name">{{ bracket.grandFinal.team2 }}</span><span
                v-if="bracket.grandFinal.score2 !== undefined" class="team-score">{{ bracket.grandFinal.score2 }}</span>
            </div>
          </div>

          <div class="round-label champion-label">Mästare</div>
          <div class="champion-box">
            <div class="champion-name">{{ bracket.champion }}</div>
          </div>
        </div>

        <div class="tree tree-right">
          <div class="tree-title">Höger Träd</div>

          <div class="bracket-round r3">
            <div class="round-label">Semifinal</div>
            <div class="match" v-for="(match, i) in bracket.right.round3" :key="'r-r3-' + i">
              <div class="match-time">{{ match.time }}</div>
              <div class="team blue-team" :class="{ winner: match.winner === match.team1 }"><span class="team-name">{{
                  match.team1 }}</span><span v-if="match.score1 !== undefined" class="team-score">{{ match.score1
                  }}</span></div>
              <div class="team red-team" :class="{ winner: match.winner === match.team2 }"><span class="team-name">{{
                  match.team2 }}</span><span v-if="match.score2 !== undefined" class="team-score">{{ match.score2
                  }}</span></div>
            </div>
          </div>

          <div class="bracket-round r2">
            <div class="round-label">Kvartsfinal</div>
            <div class="match" v-for="(match, i) in bracket.right.round2" :key="'r-r2-' + i">
              <div class="match-time">{{ match.time }}</div>
              <div class="team blue-team" :class="{ winner: match.winner === match.team1 }"><span class="team-name">{{
                  match.team1 }}</span><span v-if="match.score1 !== undefined" class="team-score">{{ match.score1
                  }}</span></div>
              <div class="team red-team" :class="{ winner: match.winner === match.team2 }"><span class="team-name">{{
                  match.team2 }}</span><span v-if="match.score2 !== undefined" class="team-score">{{ match.score2
                  }}</span></div>
            </div>
          </div>

          <div class="bracket-round r1">
            <div class="round-label">Runda 1</div>
            <div class="match" v-for="(match, i) in bracket.right.round1" :key="'r-r1-' + i">
              <div class="match-time">{{ match.time }}</div>
              <div class="team blue-team" :class="{ winner: match.winner === match.team1 }"><span class="team-name">{{
                  match.team1 }}</span><span v-if="match.score1 !== undefined" class="team-score">{{ match.score1
                  }}</span></div>
              <div class="team red-team" :class="{ winner: match.winner === match.team2 }"><span class="team-name">{{
                  match.team2 }}</span><span v-if="match.score2 !== undefined" class="team-score">{{ match.score2
                  }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CsBracketPage',
  data() {
    return {
      bracket: {
        left: {
          round1: [
            { team1: 'NUKELOVERS', team2: 'LARKERS SEGJÄRN', winner: 'LARKERS SEGJÄRN', score1: 6, score2: 13, time: 'Ons 8/4 16:00' },
            { team1: 'CAMPEONES', team2: 'SANDELS', winner: 'CAMPEONES', score1: 13, score2: 9, time: 'Ons 8/4 16:45' },
            { team1: 'SVP BOTS', team2: 'MASSIVELY OVERATED', winner: 'SVP BOTS', score1: 13, score2: 6, time: 'Ons 8/4 17:30' },
            { team1: 'SKEÅL', team2: 'CUTTING EDGE', winner: 'SKEÅL', score1: 13, score2: 4, time: 'Ons 8/4 18:15' }
          ],
          round2: [
            { team1: 'LARKERS SEGJÄRN', team2: 'CAMPEONES', winner: 'LARKERS SEGJÄRN', score1: 13, score2: 7, time: 'Tors 9/4 18:00' },
            { team1: 'SVP BOTS', team2: 'SKEÅL', winner: 'SVP BOTS', score1: 13, score2: 5, time: 'Tors 9/4 18:45' }
          ],
          round3: [
            { team1: 'LARKERS SEGJÄRN', team2: 'SVP BOTS', winner: 'SVP BOTS', score1: 2, score2: 13, time: 'Tors 9/4 21:45' }
          ]
        },
        right: {
          round1: [
            { team1: 'H.O.M.E.R', team2: 'SVEDJEHED FANCLUB', winner: 'H.O.M.E.R', score1: 13, score2: 6, time: 'Ons 8/4 19:00' },
            { team1: 'CT ACADEMY', team2: 'MILK', winner: 'MILK', score1: 0, score2: 13, time: 'Ons 8/4 19:45' },
            { team1: 'MUMINTROLLEN', team2: '954', winner: '954', score1: 6, score2: 13, time: 'Tors 9/4 16:30' },
            { team1: 'DMP FT MASKIN', team2: 'DRAKENS VÄRLD', winner: 'DMP FT MASKIN', score1: 13, score2: 2, time: 'Tors 9/4 17:15' }
          ],
          round2: [
            { team1: 'H.O.M.E.R', team2: 'MILK', winner: 'MILK', score1: 10, score2: 13, time: 'Tors 9/4 19:30' },
            { team1: '954', team2: 'DMP FT MASKIN', winner: '954', score1: 13, score2: 6, time: 'Tors 9/4 20:15' }
          ],
          round3: [
            { team1: 'MILK', team2: '954', winner: 'MILK', score1: 13, score2: 2, time: 'Tors 9/4 21:00' }
          ]
        },
        grandFinal: {
          team1: 'SVP BOTS',
          team2: 'MILK',
          score1: 0,
          score2: 1,
          winner: null,
          time: 'Lör 11/4 18:30 (Bo3)'
        },
        champion: 'TBD'
      }
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=IM+Fell+English+SC&display=swap');

.bracket-only-container {
  min-height: 100vh;
  padding: 10px;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bracket-section {
  width: 100%;
  max-width: 1920px;
  margin: 0;
  padding: 16px;
  background: rgba(20, 20, 20, 0.92);
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.45);
}

.bracket-title {
  font-family: 'IM Fell English SC', serif;
  font-size: 1.8rem;
  color: #fff;
  text-align: center;
  text-shadow: 0 2px 16px #a8180c, 0 1px 0 #000;
  margin-top: 0;
  margin-bottom: 18px;
  letter-spacing: 0.04em;
}

.ncaa-layout {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  overflow-x: auto;
  padding: 10px 0;

  --match-height: 86px;
  --match-gap: 10px;
  --tree-line: rgba(255, 215, 0, 0.35);
  --line-len: 12px;
}

.tree {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.tree-left {
  justify-content: flex-end;
}

.tree-right {
  justify-content: flex-start;
}

.tree-title {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.bracket-round {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 146px;
}

.round-label {
  font-family: 'IM Fell English SC', serif;
  font-size: 0.92rem;
  color: #a8180c;
  text-align: center;
  margin-bottom: 4px;
  text-shadow: 0 1px 4px #000;
  font-weight: bold;
}

.match {
  background: rgba(40, 40, 40, 0.9);
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #333;
  transition: transform 0.2s, box-shadow 0.2s;
  min-height: var(--match-height);
  position: relative;
}

.match-time {
  font-family: 'IM Fell English SC', serif;
  font-size: 0.72rem;
  color: #ffd700;
  text-align: center;
  padding: 3px 6px;
  background: rgba(0, 0, 0, 0.5);
  border-bottom: 1px solid #444;
  font-weight: bold;
}

.match-score {
  font-family: 'IM Fell English SC', serif;
  font-size: 0.8rem;
  color: #ffd700;
  text-align: center;
  padding: 4px 6px;
  background: rgba(0, 0, 0, 0.3);
  border-bottom: 1px solid #444;
  font-weight: bold;
}

.team {
  font-family: 'IM Fell English SC', serif;
  font-size: 0.73rem;
  color: #ccc;
  padding: 5px 7px;
  border-bottom: 1px solid #444;
  transition: background 0.2s, color 0.2s;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
}

.team-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.team-score {
  flex-shrink: 0;
  font-weight: bold;
  font-size: 1.4rem;
}

.team:last-child {
  border-bottom: none;
}

.team.blue-team {
  border-left: 4px solid #1e90ff;
  background: linear-gradient(90deg, rgba(30, 144, 255, 0.15) 0%, transparent 100%);
}

.team.red-team {
  border-left: 4px solid #dc3545;
  background: linear-gradient(90deg, rgba(220, 53, 69, 0.15) 0%, transparent 100%);
}

.team.winner {
  font-weight: bold;
  color: #ffd700;
  text-shadow: 0 0 10px #ffd700, 0 0 20px #ffd700, 0 0 30px #ffb700;
}

.r1 .match {
  margin-bottom: var(--match-gap);
}

.r1 .match:last-child {
  margin-bottom: 0;
}

.r2 {
  margin-top: calc((var(--match-height) + var(--match-gap)) / 2);
}

.r2 .match {
  margin-bottom: calc(var(--match-height) + (2 * var(--match-gap)));
}

.r2 .match:last-child {
  margin-bottom: 0;
}

.r3 {
  margin-top: calc((3 * (var(--match-height) + var(--match-gap))) / 2);
}

.center-final {
  margin-top: calc((7 * (var(--match-height) + var(--match-gap))) / 2);
  min-width: 190px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.final-match {
  border: 2px solid #a8180c;
  box-shadow: 0 0 20px #a8180c44;
  width: 100%;
}

.final-match .team {
  font-size: 0.8rem;
  padding: 6px 8px;
}

.tree-left .match::after {
  content: '';
  position: absolute;
  top: 50%;
  right: calc(-1 * var(--line-len));
  width: var(--line-len);
  border-top: 1px solid var(--tree-line);
}

.tree-right .match::before {
  content: '';
  position: absolute;
  top: 50%;
  left: calc(-1 * var(--line-len));
  width: var(--line-len);
  border-top: 1px solid var(--tree-line);
}

.center-final .final-match::before,
.center-final .final-match::after {
  content: '';
  position: absolute;
  top: 50%;
  width: var(--line-len);
  border-top: 1px solid var(--tree-line);
}

.center-final .final-match::before {
  left: calc(-1 * var(--line-len));
}

.center-final .final-match::after {
  right: calc(-1 * var(--line-len));
}

.champion-label {
  margin-top: 10px;
}

.champion-box {
  background: linear-gradient(135deg, #ffd700 0%, #ffb700 50%, #ffd700 100%);
  border-radius: 12px;
  padding: 20px 24px;
  text-align: center;
  box-shadow: 0 4px 24px rgba(255, 215, 0, 0.4);
  border: 2px solid #fff;
}

.champion-name {
  font-family: 'IM Fell English SC', serif;
  font-size: 1.2rem;
  color: #000;
  font-weight: bold;
}

@media (max-width: 1250px) {
  .ncaa-layout {
    -webkit-overflow-scrolling: touch;
  }
}
</style>
